import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

const usePanelStore = create()(
  persist(
    (set, get) => ({
      panelData: null,

      setPanelData: (data) => set({ panelData: data }),

      // Get function to retrieve specific data or the entire panel data
      get: (path) => {
        const state = get();

        if (!path) {
          return state.panelData;
        }

        // Handle nested paths like "insurerResults.quoted"
        return path
          .split(".")
          .reduce((obj, key) => obj?.[key], state.panelData);
      },

      // Set function to update specific data using a path
      set: (path, value) => {
        const state = get();

        if (!path) {
          set({ panelData: value });
          return;
        }

        const newPanelData = { ...state.panelData };
        const keys = path.split(".");
        let current = newPanelData;

        for (let i = 0; i < keys.length - 1; i++) {
          if (!current[keys[i]]) {
            current[keys[i]] = {};
          }
          current = current[keys[i]];
        }

        current[keys[keys.length - 1]] = value;

        set({ panelData: newPanelData });
      },

      // Clear panel data
      clear: () => set({ panelData: null }),

      // Reset method for consistency with other stores
      reset: () => set({ panelData: null }),
    }),
    {
      name: "panel-store",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

export default usePanelStore;
